import { render, staticRenderFns } from "./AboutHistoryIntro.vue?vue&type=template&id=0e473c4a&"
import script from "./AboutHistoryIntro.vue?vue&type=script&lang=js&"
export * from "./AboutHistoryIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports